module.exports = __webpack_public_path__ + "img/EarlyBird.eaf4a3cb.png";